import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
    selector: 'ng-template[matAddonField]',
})
export class GenericFieldAddonDirective {
    @Input() public matAddonField: string | string[] | null;

    constructor(public template: TemplateRef<unknown>) {
    }

}
